export default __webpack_public_path__ + "static/media/docs.cd08b4a3.svg";